module.exports = __webpack_public_path__ + "static/media/1983 San Francisco, USA​.de787106.jpg";